import { createContext, useContext } from 'react';
var TabMenuContext = createContext(undefined);
export var useTabMenuContext = function () {
    var context = useContext(TabMenuContext);
    if (!context) {
        throw new Error('useTabMenuContext must be used within TabMenuProvider (DP routes)');
    }
    return context;
};
export default TabMenuContext;
